export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Questa azione eliminerà definitivamente l'asset"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sei sicuro di voler continuare?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sì"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non vedrai più questo asset nella tua lista."])}
}